<template>
    <div>
        <h1>{{ user.firstName }} {{ user.name }}</h1>
        <h2>Role : {{user.role}}</h2>
        <h2>Mail : {{user.mail}}</h2>
        <h2 v-if="user.note">Notes : {{user.note}}</h2>
        <br/>
        <!-- Gestion des Clés de Script -->        
        <div v-if='scriptkeys.length > 0'>
            <h2 class='component_title'>Clé(s) de script :</h2>

            <div id="scriptTab" class="pl-list">
                <div class="header">
                    <div class="header_line">
                        <div id="header_col1" class="header_col col1">Clé(s) de script</div>
                        <div id="header_col4" class="header_col col4">Note</div>
                    </div>
                </div>
            
                <div class="content" ref="scriptBox">
                    <scriptline v-for="(script) in scriptkeys" :key='script.id' :scriptObj='script'   ></scriptline>

                    <div class="dummyline" :style="{'height': dummyScriptHeight+'px'}">
                        <div class="col col1">&nbsp;</div>
                        <div class="col col2">&nbsp;</div>
                    </div>
                </div>
                <div class="footer">
                    <div class="buttons">
                        <button id="btn_addScript" type="button" class="liste_btn boutonTableau" title="Ajouter" @click="clickBtnAddScript()">Ajouter</button>
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            <br/>
            <a id="link_addScript" class="link_host" title="Ajouter" @click='clickBtnAddScript()'>Ajouter une clé de script</a>
        </div>

        <br/>
        <!-- Si c'est notre page d'info, on peux changer notre mot de passe -->
        <div v-if="this.$store.state.currentUser.id == user.id" id="formMdp">
            <h2>Changer mon mot de passe :</h2>
            <br/>
            <label>Ancien mot de passe :</label>
            <div class="form_row" >
                <input v-model="old_pass" class="form_input" type="password" placeholder="Ancien mot de passe" name='oldPass' />
            </div>

            <label>Nouveau mot de passe :</label>
            <div class="form_row" >
                <input v-model="new_pass1" class="form_input" type="password" placeholder="Nouveau mot de passe" name='newPass1' />
            </div>

            <label>Confirmation du nouveau mot de passe :</label>
            <div class="form_row" >
                <input v-model="new_pass2" class="form_input" type="password" placeholder="Confirmation du nouveau mot de passe" name='newPass2' />
            </div>

            <button class="form_button" :class="{'form_button_disabled' : (!canChangeMDP())}" :disabled="!canChangeMDP()" @click="sandChangeMDP()">
                <span >Changer de mot de passe</span>
            </button>

        </div>


    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import ScriptLine from '@/components/ScriptLine';

    export default {
        name: "User",
        components:{
            "scriptline":ScriptLine,
        },
        mixins: [FctUtils],
        props :{
            userId : {}
        },
        data(){
            return {
                user:{},
                old_pass:"",
                new_pass1:"",
                new_pass2:"",
                //
                scriptkeys: {},
                dummyIPHeight: 25,
            }
        },
        created() {
            axios(diagonalbackURL + "/users/"+ this.userId,  defaultConfig)
            .then(reponse => {
                this.user = reponse.data;

                axios(diagonalbackURL + "/users/"+ this.user.id + "/apikeys",  defaultConfig)
                .then(reponse => {
                    console.log(reponse)
                    this.scriptkeys = reponse.data;
                })
                .catch(error => this.errorHandler(error));
            })
            .catch(error => this.errorHandler(error));
        },
        mounted() {
            this.emitter.on('createScript', newScriptData => {
                this.addScript(newScriptData)
            });
            this.emitter.on('editScript', scriptdata => {
                this.editScript(scriptdata)
            });
            this.emitter.on('removeScript', scriptdata => {
                this.removeScript(scriptdata)
            });
        },
        updated() {
            this.calcDummyScriptHeight();
        }, 
        
        watch : {
            scriptkeys: function (newQuestion, oldQuestion) {
                console.log("watching!")
                this.calcDummyScriptHeight();
            },
        },
        methods: {
            canChangeMDP() {
                return this.old_pass!= "" && this.new_pass1 != "" && this.new_pass1 == this.new_pass2 && this.new_pass1 != this.old_pass;
            },
            sandChangeMDP() {

                const params = JSON.stringify({
                    'password':this.old_pass,
                    'newPassword':this.new_pass1,
                });

                axios.post(diagonalbackURL + "/users/"+this.user.id + "/password", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
            clickBtnAddScript(){
                this.emitter.emit('showPLForm', {mode: 'formScript_new'});
            },
            addScript(newScriptData) {
                // Attention : on reçoit la note dans .name, car pas besoin de nom pour cette clé la
                const params = JSON.stringify({
                    'userId':this.user.id,
                    'note':newScriptData.name,
                });

                axios.put(diagonalbackURL + "/users/"+ this.user.id + "/apikeys", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
            editScript(scriptdata) {

            },
            removeScript(scriptdata) {

            },
            calcDummyScriptHeight() {
                var calcHeight = 25;

                if (this.scriptkeys != undefined && this.scriptkeys.length > 0 ) {
                    // Astuce : Quand il y a peux de ligne, le $ref et scriptBox ne sont pas bien initialisé
                    // Je ne vois pas la diff avec les autres cas de Host qui fonctionne normalement
                    var totalheight = (this.$refs.scriptBox != undefined) ? this.$refs.scriptBox.scrollHeight : 100; 
                    calcHeight = totalheight - (this.scriptkeys.length*27); 
                }
                
                this.dummyScriptHeight = calcHeight;
            },
        }
    }
</script>


<style>

#formMdp .form_row {
    margin-top : 8px;
}

#scriptTab.pl-list .col1 {
    width:250px;
}

#scriptTab.pl-list .col2 {
    border: none;
    width:auto;
}

</style>
